import type { ProjectStatus, SyncState } from "../api/types";

export const PROJECT_STATUS_LABELS: Record<string, string> = {
  ALL: "전체 상태",
  ESTIMATING: "견적 중",
  ACTIVE: "진행 중",
  IN_PROGRESS: "진행 중",
  ON_HOLD: "보류",
  COMPLETED: "완료",
  CANCELLED: "취소",
};

export const SYNC_STATUS_LABELS: Record<SyncState, string> = {
  SYNCED: "시트 동기화 완료",
  PENDING: "시트 동기화 대기",
  RUNNING: "시트 동기화 중",
  ERROR: "시트 동기화 오류",
  DISABLED: "시트 동기화 꺼짐",
};

export function projectStatusLabel(status: ProjectStatus | string) {
  return PROJECT_STATUS_LABELS[status] ?? status;
}

export function formatMoney(value?: number) {
  if (value === undefined || value === null || Number.isNaN(value)) return "—";
  return `${Math.round(value).toLocaleString("ko-KR")}원`;
}

export function formatDate(value?: string, options?: Intl.DateTimeFormatOptions) {
  if (!value) return "—";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  return new Intl.DateTimeFormat("ko-KR", {
    timeZone: "Asia/Seoul",
    ...(options ?? { year: "2-digit", month: "2-digit", day: "2-digit" }),
  }).format(date);
}

export function formatDateTime(value?: string) {
  return formatDate(value, {
    month: "numeric",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

function seoulParts(date: Date) {
  return new Intl.DateTimeFormat("en-US", {
    timeZone: "Asia/Seoul",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    hourCycle: "h23",
  }).formatToParts(date).reduce<Record<string, string>>((result, part) => {
    if (part.type !== "literal") result[part.type] = part.value;
    return result;
  }, {});
}

export function todayInputValue(date = new Date()) {
  const parts = seoulParts(date);
  return `${parts.year}-${parts.month}-${parts.day}`;
}

export function seoulDateTimeInputValue(date = new Date()) {
  const parts = seoulParts(date);
  return `${parts.year}-${parts.month}-${parts.day}T${parts.hour}:${parts.minute}`;
}

export function seoulDateTimeInputToIso(value: string) {
  return new Date(`${value}:00+09:00`).toISOString();
}
